// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-footer_container__VwjfL","top":"business-hub-footer_top__THPdg","background":"business-hub-footer_background__ez1G7"};